import * as React from 'react'
import * as jotai from 'jotai'

import * as api from '@owl-nest/api-client/next'
import * as hooks from '@owl-nest/hooks'

import * as base from './api'

const NEWS_PIECE_CACHE = jotai.atom<hooks.Cache<api.News>>({})

type NewsPieceConfig = {
  fetchOnMount?: boolean | 'force'
  withToken?: boolean
}

export function useNewsPiece(newsPieceId: number, { fetchOnMount = true, withToken = false }: NewsPieceConfig) {
  const { getCurrentResponse, query: queryNewsPiece } = hooks.useSharedQuery(
    (newsPieceId) => base.get(newsPieceId, withToken),
    {
      atom: NEWS_PIECE_CACHE,
      id,
    },
  )

  hooks.useFetchOnMount({ fetchOnMount, query, getResponse }, id(newsPieceId, withToken))

  return { response: getResponse(), query }

  function getResponse(): hooks.Response<api.News> {
    const response = getCurrentResponse([newsPieceId, withToken])

    if (response === undefined) {
      return { status: hooks.QueryStatus.PRISTINE }
    }

    return response
  }

  function id(newsPieceID: number, withToken: boolean): string {
    return JSON.stringify([newsPieceID, withToken])
  }

  async function query(): Promise<void> {
    return queryNewsPiece(newsPieceId, withToken)
  }
}
